import React from 'react';
import { Button,Popover } from 'antd';
import {isMobile} from 'react-device-detect';

const title = "旅行行程を見る";
const iw = (isMobile)?345:259;

const Schedule = (data) => (
  <div className="row mb-2">
    <div className="col-12">
      {data.schedule ?
        <Popover placement="bottom"
                 title={title}
//                 onVisibleChange={() => {gtmEvent('click', 'ad', data.url)}}
                 content={
                   <section style={{width: iw}}>
                     {data.schedule.map((item, index) => (
                       <div key={index} className="row">
                         <div className="col-3">
                           {item.time}
                         </div>
                         <div className="col-9">
                           {item.title}
                         </div>
                       </div>
                     ))}
                     <div className="mt-3">
                       <a href={data.url + "#section-schedule"}>
                         <Button type="primary">
                           ツアーのスケジュールをみる
                         </Button>
                       </a>
                     </div>
                   </section>
                 }
                 trigger="click">
          <Button className="primary btn-block"><i className="fa fa-plane" aria-hidden="true"></i> {title}</Button>
        </Popover>
        :
        <a href={data.url + "#section-schedule"}>
          <Button className="primary btn-block">{title}</Button>
        </a>
      }
    </div>
  </div>
);

export default Schedule;


// WEBPACK FOOTER //
// ./src/pages/ad/components/Schedule.js